import {
  EdgelessClipboardConfig,
  type PreparedEdgelessBlock,
} from '@blocksuite/affine-block-surface';
import { type BlockSnapshot } from '@blocksuite/store';

export class EdgelessClipboardEmbedLoomConfig extends EdgelessClipboardConfig {
  static override readonly key = 'affine:embed-loom';

  override prepareBlock(loomEmbed: BlockSnapshot): PreparedEdgelessBlock {
    return {
      create: () => {
        if (!this.surface) return null;
        const {
          xywh,
          style,
          url,
          caption,
          videoId,
          image,
          title,
          description,
        } = loomEmbed.props;

        const embedLoomId = this.crud.addBlock(
          'affine:embed-loom',
          {
            xywh,
            style,
            url,
            caption,
            videoId,
            image,
            title,
            description,
          },
          this.surface.model.id
        );
        return embedLoomId;
      },
    };
  }
}
